const topics = [
  { label: '庆余年第三季', hot: true },
  { label: '玫瑰的故事', hot: true },
  { label: '长相思2', hot: true },
  { label: '墨雨云间', hot: false },
  { label: '承欢记', hot: false },
  { label: '与凤行', hot: true },
  { label: '国漫崛起', hot: false },
  { label: '悬疑剧场', hot: false },
  { label: '古装大剧', hot: true },
  { label: '高分电影', hot: false },
];

export default function Topics() {
  return (
    <section id="topics" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-semibold rounded-full uppercase tracking-wide">
            热门话题
          </span>
          <h2 className="mt-4 text-2xl md:text-3xl font-bold text-foreground-950">大家都在搜 · 热门影视话题</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            全网热播剧集话题一网打尽，看看大家都在追什么好剧。
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((t) => (
            <span
              key={t.label}
              className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium cursor-pointer transition-all duration-200 hover:scale-105 whitespace-nowrap ${
                t.hot
                  ? 'bg-primary-500 text-background-50 shadow-sm'
                  : 'bg-background-50 text-foreground-700 border border-background-200 hover:border-primary-300 hover:text-primary-600'
              }`}
            >
              {t.hot && <i className="ri-fire-line text-xs"></i>}
              {t.label}
              {t.hot && <span className="text-[10px] opacity-80">HOT</span>}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}